import AffiliateForm from "./AffiliateForm";

export default AffiliateForm;
